import { TextInput, Label, Row, Column } from '../../../components'
import React, { forwardRef } from 'react'

interface Props {
  value: string
  label?: string
  name: string
  isEditable?: boolean
  type?: 'text' | 'email' | 'number' | 'tel' | 'password'
  placeholder?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  isRequired?: boolean
  feedback?: string
  isInvalid?: boolean
  className?:string
  labelClass?:string
  labelColClassName?:string
  maxLength?:number
  tabIndex?:number
  lglabel?:number,
  mdlabel?:number,
  lgText?:number,
  mdText?:number,
  isEmpty?:boolean
  isTooShort?:boolean
  isTooLong?:boolean,
  isSame?:boolean
  errorText?:string
  invalidWarning?:string,
  invalidLableClass? : string
  textInputContainerClass? : string,
  autofocus?: boolean
  ref?: any
  onKeyDown?:any
  onBlur?:any
}

const inputStyle = {
  // width:'100%',
  // height:'30px',
  //  fontSize:'small'
 }
 const labelStyle={
  //  fontSize:'small'

 }
 const TextInputWithLabelInline = forwardRef<HTMLInputElement, Props>((props, ref) => {  const {
    value,
    label,
    name,
    isEditable,
    onChange,
    placeholder,
    type,
    isRequired,
    feedback,
    isInvalid,
    className,
    labelClass,
    labelColClassName,
    maxLength,
    tabIndex,
    lglabel,
    mdlabel,
    lgText,
    mdText,
    isEmpty,
    isTooShort,
    isTooLong,
    isSame,
    errorText,
    invalidWarning,
    invalidLableClass,
    textInputContainerClass,
    autofocus,
    onKeyDown,
    onBlur,
  } = props
  const id = `${name}TextInput`
  return (
    <Row className=''>
      {label && <Column lg={lglabel} md={mdlabel} className={labelColClassName}>
        <Label text={label} htmlFor={id} isRequired={isRequired} className={labelClass} style={labelStyle} />
      </Column>}
      <Column lg={lgText} md={mdText} className={`${textInputContainerClass}`}>
        <TextInput
          feedback={feedback}
          id={id}
          isInvalid={isInvalid}
          value={value}
          disabled={!isEditable}
          onChange={onChange}
          type={type ? type : 'text'}
          placeholder={placeholder || label}
          className={className}
          style={inputStyle}
          maxLength={maxLength}
          tabIndex={tabIndex}
          isEmpty={isEmpty}
          isTooShort={isTooShort}
          isTooLong={isTooLong}
          isSame={isSame}
          errorText={errorText}
          invalidWarning={invalidWarning}
          invalidLableClass={invalidLableClass}
          autofocus = {autofocus}
          ref= {ref}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
        />
      </Column>
    </Row>
  );
})

TextInputWithLabelInline.defaultProps = {
  value: '',
  type: 'text',
}


export default TextInputWithLabelInline
